(function () { // eslint-disable-line
    var productTriggers = document.querySelectorAll('[gr-product-trigger]'),
        productContents = document.querySelectorAll('[gr-product-content]'),
        maxTriggers,
        indexTriggers,
        currentTriggerIndex,
        maxContent,
        indexContent;

    // Check if elems exists
    if ( productTriggers && productContents ) {
        init();
    }

    function init() {

        for (indexTriggers = 0, maxTriggers = productTriggers.length; indexTriggers < maxTriggers; indexTriggers++) {
            productTriggers[indexTriggers].setAttribute('gr-product-trigger', indexTriggers);
            productContents[indexTriggers].setAttribute('gr-product-trigger', indexTriggers);

            // Set the first elem of matcher elems active
            productTriggers[0].classList.add('product-showcase__trigger--active');
            productContents[0].style.display = "block";

            productTriggers[indexTriggers].addEventListener('click', function(e) {
                e.preventDefault();

                currentTriggerIndex = this.getAttribute('gr-product-trigger');

                // Call the handlers to show the clicked elems
                toggleTrigger(currentTriggerIndex);
                toggleContent(currentTriggerIndex);
            });

        }
    }

    // Toggle the content with the matched index
    function toggleContent(el) {
        for (indexContent = 0, maxContent = productContents.length; indexContent < maxContent; indexContent++) {
            productContents[indexContent].style.display = "none";
            productContents[el].style.display = "block";
        }
    }

    // Toggle the active class on triggers
    function toggleTrigger(el) {
        for (indexTriggers = 0, maxTriggers = productTriggers.length; indexTriggers < maxTriggers; indexTriggers++) {
            productTriggers[indexTriggers].classList.remove('product-showcase__trigger--active');
            productTriggers[el].classList.add('product-showcase__trigger--active');

        }
    }
}());

